export interface IChangePasswordRequest {
  userName: string;
  oldPassword: string;
  newPassword: string;
}

export interface IChangePasswordResponse {
  result: ChangePasswordResult;
}

export enum ChangePasswordResult {
  PasswordChangedSuccessfully,
  OldPasswordInCorrect,
  NewPasswordRecentlyUsed,
  PasswordIsInvalid
}
